import React from 'react';
import { useChatStore } from '../stores/chat-store';

interface FeedbackButtonsProps {
  messageId: string;
}

const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({ messageId }) => {
  const { submitFeedback } = useChatStore();

  return (
    <div className="flex items-center gap-1 mt-1">
      <button
        aria-label="Thumbs up"
        className="p-1 text-text-muted hover:text-success rounded transition-colors"
        onClick={() => submitFeedback(messageId, 'helpful')}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z" />
          <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
        </svg>
      </button>
      <button
        aria-label="Thumbs down"
        className="p-1 text-text-muted hover:text-error rounded transition-colors"
        onClick={() => submitFeedback(messageId, 'unhelpful')}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3H10z" />
          <path d="M17 2h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3" />
        </svg>
      </button>
    </div>
  );
};

export default FeedbackButtons;
